import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  LayoutDashboard, User, Code2, Briefcase,
  Award, MessageSquare, Globe, LogOut, Menu, X, ChevronRight,
} from 'lucide-react';

const navItems = [
  { to: '/admin/dashboard', icon: <LayoutDashboard size={16} />, label: 'Dashboard' },
  { to: '/admin/profile', icon: <User size={16} />, label: 'Profil & Hero' },
  { to: '/admin/services', icon: <Briefcase size={16} />, label: 'Layanan' },
  { to: '/admin/skills', icon: <Code2 size={16} />, label: 'Keahlian' },
  { to: '/admin/portfolio', icon: <Briefcase size={16} />, label: 'Portfolio' },
  { to: '/admin/gallery', icon: <Award size={16} />, label: 'Galeri' },
  { to: '/admin/testimonials', icon: <MessageSquare size={16} />, label: 'Testimoni' },
  { to: '/admin/certifications', icon: <Award size={16} />, label: 'Sertifikasi' },
  { to: '/admin/blog', icon: <Globe size={16} />, label: 'Blog / Artikel' },
  { to: '/admin/messages', icon: <MessageSquare size={16} />, label: 'Pesan Masuk' },
  { to: '/admin/site', icon: <Globe size={16} />, label: 'Pengaturan Site' },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = async () => { await logout(); navigate('/admin'); };
  const W = collapsed ? 64 : 240;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg)', fontFamily: "'DM Sans', sans-serif" }}>

      {/* Sidebar */}
      <div style={{
        width: W, flexShrink: 0,
        background: 'var(--surface)',
        borderRight: '1px solid rgba(255,255,255,0.05)',
        display: 'flex', flexDirection: 'column',
        transition: 'width 0.25s ease',
        position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 100,
        overflow: 'hidden',
      }}>
        {/* Top */}
        <div style={{ padding: '20px 16px', borderBottom: '1px solid rgba(255,255,255,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', minHeight: 64 }}>
          {!collapsed && (
            <div style={{ overflow: 'hidden' }}>
              <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 16, color: '#f2f2ff', whiteSpace: 'nowrap', letterSpacing: '-0.3px' }}>
                EP<span style={{ display: 'inline-block', width: 5, height: 5, borderRadius: '50%', background: '#00e5ff', marginLeft: 2, verticalAlign: 'middle', marginBottom: 2 }} />
              </div>
              <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, color: '#6a6a88', letterSpacing: 2, whiteSpace: 'nowrap' }}>ADMIN</div>
            </div>
          )}
          <button onClick={() => setCollapsed(!collapsed)}
            style={{ background: 'none', border: 'none', color: '#6a6a88', cursor: 'pointer', padding: 4, flexShrink: 0, marginLeft: collapsed ? 'auto' : 0 }}>
            {collapsed ? <Menu size={15} /> : <X size={15} />}
          </button>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '12px 8px', overflowY: 'auto' }}>
          {navItems.map(item => (
            <NavLink key={item.to} to={item.to}
              title={collapsed ? item.label : undefined}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center',
                gap: collapsed ? 0 : 10,
                padding: collapsed ? '10px' : '10px 12px',
                borderRadius: 3, marginBottom: 2,
                textDecoration: 'none',
                color: isActive ? '#f2f2ff' : '#6a6a88',
                background: isActive ? 'rgba(255,255,255,0.06)' : 'transparent',
                fontWeight: isActive ? 600 : 400,
                fontSize: 13,
                transition: 'all 0.15s',
                justifyContent: collapsed ? 'center' : 'flex-start',
                position: 'relative',
              })}
              onMouseEnter={e => {
                if (!e.currentTarget.style.background.includes('0.06')) {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
                  e.currentTarget.style.color = '#c0c0d0';
                }
              }}
              onMouseLeave={e => {
                if (!e.currentTarget.style.background.includes('0.06')) {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#6a6a88';
                }
              }}
            >
              {({ isActive }) => (
                <>
                  {isActive && !collapsed && <div style={{ position: 'absolute', left: 0, top: '20%', bottom: '20%', width: 2, background: 'linear-gradient(180deg, #00e5ff, #9b00ff)', borderRadius: 1 }} />}
                  <span style={{ flexShrink: 0, marginLeft: isActive && !collapsed ? 6 : 0 }}>{item.icon}</span>
                  {!collapsed && <span style={{ whiteSpace: 'nowrap' }}>{item.label}</span>}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        {/* User */}
        <div style={{ padding: '12px 8px', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
          {!collapsed && (
            <div style={{ padding: '8px 12px', marginBottom: 4 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: '#f2f2ff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.email}</div>
              <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, color: '#6a6a88', letterSpacing: 1 }}>ADMINISTRATOR</div>
            </div>
          )}
          <button onClick={handleLogout}
            title={collapsed ? 'Keluar' : undefined}
            style={{
              width: '100%', display: 'flex', alignItems: 'center',
              gap: collapsed ? 0 : 10,
              padding: collapsed ? '10px' : '10px 12px',
              borderRadius: 3, background: 'none', border: 'none',
              color: '#6a6a88', cursor: 'pointer', fontSize: 13,
              transition: 'all 0.15s',
              justifyContent: collapsed ? 'center' : 'flex-start',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(239,68,68,0.08)'; e.currentTarget.style.color = '#ef4444'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = '#6a6a88'; }}
          >
            <LogOut size={16} />
            {!collapsed && <span>Keluar</span>}
          </button>
        </div>
      </div>

      {/* Main */}
      <div style={{ marginLeft: W, flex: 1, transition: 'margin-left 0.25s ease', minHeight: '100vh' }}>
        {/* Topbar */}
        <div style={{
          height: 56, background: 'var(--surface)',
          borderBottom: '1px solid rgba(255,255,255,0.05)',
          display: 'flex', alignItems: 'center',
          padding: '0 28px', justifyContent: 'space-between',
          position: 'sticky', top: 0, zIndex: 50,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, color: '#6a6a88', letterSpacing: 1 }}>ERWINPAISAL.ID</span>
            <ChevronRight size={12} color='rgba(255,255,255,0.15)' />
            <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, color: '#6a6a88', letterSpacing: 1 }}>ADMIN</span>
          </div>
          <a href='/' target='_blank' rel='noreferrer'
            style={{
              display: 'flex', alignItems: 'center', gap: 6,
              padding: '6px 14px', borderRadius: 3,
              border: '1px solid rgba(255,255,255,0.08)',
              color: '#6a6a88', textDecoration: 'none',
              fontFamily: "'DM Mono', monospace",
              fontSize: 10, letterSpacing: 1,
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(0,229,255,0.3)'; e.currentTarget.style.color = '#00e5ff'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = '#6a6a88'; }}
          >
            <Globe size={12} /> LIHAT WEBSITE
          </a>
        </div>
        <div style={{ padding: 28 }}>{children}</div>
      </div>
    </div>
  );
}
